import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from '@mui/material/Modal';
import './styles.scss';
import salesHierarchyIcon from '../../images/sales-hierarchy-icon.png';
import modalCloseIcon from '../../images/modal-close-icon.png';
import ExpandedInventorySummary from '../ExpandedInventorySummary';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
const InventoryModal = (props) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [modalTitle, setModalTitle] = useState(props.title);
  const [titleInModal, setTitleInModal] = useState(props.titleInModal);

  let ExpandeSummaryTopRowContainer = '';
  let ExpandeSummaryContentContainer = '';

  let modalSummaryTitle = null;
  if (props.ExpandedInventorySummaryComponent === 'true') {
    modalSummaryTitle = titleInModal;
  } else if (props.titleInModal) {
    modalSummaryTitle = props.titleInModal;
  }

  const modalBodyRef = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const modalBody = modalBodyRef.current;
    if (!modalBody) {
      return undefined;
    }
    const stopModalContentPropagation = (e) => {
      e.stopPropagation();
    };
    modalBody.addEventListener('click', stopModalContentPropagation);
    return () => {
      modalBody.removeEventListener('click', stopModalContentPropagation);
    };
  }, [open]);

  const body = (
    <div ref={modalBodyRef} className="modal-body-container">
      <div className="modal-header-container">
        <button
          type="button"
          aria-label="Close"
          className="modal-close-btn-icon"
          onClick={handleClose}
        >
          <img alt="" src={modalCloseIcon} />
        </button>
        <h1
          className="modal-heading"
          id="simple-modal-title"
          data-testid="simple-modal-title"
        >
          {modalTitle === null || modalTitle === undefined ? null : modalTitle}
        </h1>
      </div>
      <div className="modal-content">
        {modalSummaryTitle ? (
          <div className="modal-content-summaryData-title">
            <h1 className="modal-summaryData-title">{modalSummaryTitle}</h1>
          </div>
        ) : null}

        {props.modalContentOther ? (
          <TableContainer
            className={`modal-content-data-row table-container-wrapper ${ExpandeSummaryTopRowContainer} `}
            style={{ height: '100%', borderBottom: 0 }}
          >
            <Table
              style={{ minWidth: '767px', height: '100%' }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>{props.modalContentOther}</TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    colSpan={6}
                    className={`modal-content-summaryData-container ${ExpandeSummaryContentContainer}`}
                    style={{ padding: 0 }}
                  >
                    {props.ExpandedInventorySummaryComponent === 'true' ? (
                      <ExpandedInventorySummary
                        primaryLocationNumber={props.primaryLocationNumber}
                        primaryLocationName={props.primaryLocationName}
                        selectedDateMatrix={props.selectedDateMatrix}
                        getModalTitle={setModalTitle}
                        getTitleInModal={setTitleInModal}
                      />
                    ) : null}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        ) : null}
      </div>
    </div>
  );

  return (
    <div className="modal-container">
      <button className="modal-open-btn" type="button" onClick={handleOpen}>
        <img
          alt="open modal"
          className="modal-open-btn-img"
          src={salesHierarchyIcon}
        />
      </button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
};

InventoryModal.propTypes = {
  title: PropTypes.string,
  titleInModal: PropTypes.string,
  ExpandedInventorySummaryComponent: PropTypes.string,
  primaryLocationNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  primaryLocationName: PropTypes.string,
  selectedDateMatrix: PropTypes.string,
  modalContentOther: PropTypes.node,
};

export default InventoryModal;
